module.exports = __webpack_public_path__ + "static/media/ProximaNova-Black.2b116619.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova/ProximaNova-Black.eot
// module id = 73
// module chunks = 0